var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'ai-actionable cursor-pointer',
    _vm.isButton ? 'button button--fixed' : 'badge badge--absolute',
  ],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"pa-0 ma-0",attrs:{"color":"blue lighten-1","size":"12"}},[_vm._v("mdi-creation-outline")]),_c('span',{staticClass:"caption ml-1"},[_vm._v(" "+_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }